<template>
  <div id="action-plan-page">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <p class="lead m-0">Plano de Ação</p>
          </div>
        </div>
      </div>

      <div>
        <Filter @filter="onFilter" />
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="container">
            <div class="card">
              <div class="card-body loadable">
                <div class="container-fluid" v-if="!loading">
                  <div class="row">
                    <div class="col-12 card-title">Riscos do levantamento</div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <div class="statement-description">
                        Equipamentos levantados:
                        {{ general_statement.total_machines }}
                      </div>
                      <div class="statement-description">
                        Equipamentos não conformes:
                        {{ general_statement.total_machines_noncompliance }}
                      </div>
                      <div class="statement-description">
                        Não conformidades levantadas:
                        {{ general_statement.total_noncompliances }}
                      </div>
                      <div class="statement-description">
                        Itens em desacordo NR-12:
                        {{ general_statement.total_noncompliances }}
                      </div>
                      <div class="statement-description">
                        Multa prevista: {{ getFine() }}
                      </div>
                    </div>
                    <div class="col-5 loading-info" v-if="loading">
                      Carregando informações...
                    </div>
                    <div class="col-5" v-if="!loading">
                      <table class="w-100">
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in general_statement.machines_risk_status"
                            :key="index"
                          >
                            <td class="d-flex align-items-center">
                              <div
                                class="round-circle"
                                :style="{
                                  'background-color': item.color,
                                }"
                              ></div>
                              <div class="risk-description">
                                {{ item.name }}
                              </div>
                            </td>
                            <td class="risk-description text-right">{{ item.result }}</td>
                          </tr>
                          <tr style="height: 47px">
                            <td class="risk-description">Total:</td>
                            <td class="risk-description text-right">
                              {{ general_statement.total_situations }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row" v-if="chartReady">
                    <div
                      class="
                        col-12
                        chart-col
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <apexchart
                        width="500"
                        :options="chartOptions"
                        :series="series"
                      ></apexchart>
                    </div>
                  </div>
                </div>

                <div class="loading-panel" v-if="loading">
                  <ProgressSpinner />
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body loadable">
                <div class="container-fluid" v-if="!loading2">
                  <div class="row">
                    <div class="col-12 card-title">Riscos atuais</div>
                  </div>
                  <div class="row" v-if="chartReady2">
                    <div
                      class="
                        col-7
                        chart-col
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <apexchart
                        width="500"
                        :options="chartOptions2"
                        :series="series2"
                      ></apexchart>
                    </div>
                    <div class="col-5 loading-info" v-if="loading2">
                      Carregando informações...
                    </div>
                    <div class="col-5" v-if="!loading2">
                      <table class="w-100">
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in general_statement_atual.machines_risk_status"
                            :key="index"
                          >
                            <td class="d-flex align-items-center">
                              <div
                                class="round-circle"
                                :style="{
                                  'background-color': item.color,
                                }"
                              ></div>
                              <div class="risk-description">
                                {{ item.name }}
                              </div>
                            </td>
                            <td class="risk-description text-right">{{ item.result }}</td>
                          </tr>
                          <tr style="height: 47px">
                            <td class="risk-description">Total:</td>
                            <td class="risk-description text-right">
                              {{ general_statement_atual.total_situations }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="loading-panel" v-if="loading2">
                  <ProgressSpinner />
                </div>
              </div>
            </div>

            <phases></phases>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  import ProgressSpinner from 'primevue/progressspinner'

  import Phases from './components/Phases'
  import Filter from '@/components/common/Filter/Filter.vue'

  import { NTN_ROLAMENTOS_ID } from '@/constants/config.constants.js'
  import { useRouter } from 'vue-router'

  export default {
    components: {
      ProgressSpinner,
      Phases,
      Filter,
    },
    setup() {
      const store = useStore()
      const router = useRouter()
      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)

      return {
        selected_company,
        selected_order_of_service,
        NTN_ROLAMENTOS_ID,

        router,
      }
    },
    data() {
      return {
        chartReady: false,
        loading: false,
        general_statement: {},
        series: [],
        chartOptions: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: [],
          colors: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
              },
            },
          ],
          legend: {
            show: false
          },
        },
        chartReady2: false,
        loading2: false,
        general_statement_atual: {},
        series2: [],
        chartOptions2: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: [],
          colors: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
              },
            },
          ],
          legend: {
            show: false
          },
        },
      }
    },
    mounted() {
      this.getData(), this.getData2()
    },
    methods: {
      getData() {
        var app = this

        app.loading = true

        if (this.selected_order_of_service.id) {
          this.reload = false

          this.series = []
          this.chartOptions.labels = []
          this.chartOptions.colors = []

          app.axios
            .get(
              `/api/orders_of_service/actionPlanStatement/${this.selected_order_of_service.id}`,
            )
            .then(({ data }) => {
              this.general_statement = data
              this.mountChart()
            })
            .catch((error) => {
              //console.log(error)
            })
            .finally(() => {
              app.loading = false
              this.reload = true
            })
        }
      },
      mountChart() {
        this.general_statement.machines_risk_status.forEach((el) => {
          this.series.push(el.result)
          this.chartOptions.labels.push(el.name)
          this.chartOptions.colors.push(el.color)
        })

        this.chartReady = true
      },
      getData2() {
        var app = this

        app.loading2 = true

        if (this.selected_order_of_service.id) {
          this.reload2 = false

          this.series2 = []
          this.chartOptions2.labels = []
          this.chartOptions2.colors = []

          app.axios
            .get(
              `/api/orders_of_service/actionPlanStatementAtual/${this.selected_order_of_service.id}`,
            )
            .then(({ data }) => {
              this.general_statement_atual = data
              this.mountChart2(this.general_statement_atual)
            })
            .catch((error) => {
              //console.log(error)
            })
            .finally(() => {
              app.loading2 = false
              this.reload2 = true
            })
        }
      },
      mountChart2() {
        this.general_statement_atual.machines_risk_status.forEach((el) => {
          this.series2.push(el.result)
          this.chartOptions2.labels.push(el.name)
          this.chartOptions2.colors.push(el.color)
        })

        this.chartReady2 = true
      },

      onFilter(event) {
        // this.getData(event);
        //console.log(event)
        //redirecionar para lista de formulários desconsiderando a fase
        this.router.push({
          name: 'action-plan-form',
          params: {
            filters: JSON.stringify(event),
          },
        })
      },

      getFine() {
        if (this.selected_company.id == NTN_ROLAMENTOS_ID)
          return 'R$ 2.097.590,10'
        
        const value = this.general_statement.total_max_fine

        if (!value)
          return '-'

        const formatter = Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2
        });

        return formatter.format(value)
      }
    },
    watch: {
      selected_order_of_service() {
        this.getData(), this.getData2()
      },
    },
  }
</script>

<style lang="scss" scoped>
  #action-plan-page {
    .card {
      margin-bottom: 26px;
      min-height: 900px;
    }
    .card-title {
      text-align: center;
      font-weight: 500;
      font-size: 32px;
      color: #7e7e7e;
      margin-bottom: 25px;
    }
    .statement-description,
    .risk-description {
      font-weight: 500;
      font-size: 20px;
      color: #7e7e7e;
    }
    .round-circle {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 10px;
    }
    table {
      tr {
        border-bottom: 1px solid rgb(165, 165, 165);
      }
      td {
        margin-bottom: 7px;
        margin-top: 7px;
      }
    }
    .chart-col {
      margin-top: 50px;
    }
    .loading-info {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      color: #7e7e7e;
    }

    .loadable {
      position: relative;

      .loading-panel {
        position: absolute;
        top: 0;
        left: 0;

        height: 100%;
        width: 100%;

        background-color: #e9ecef;

        display: flex;
        align-items: center;
        justify-content: center;

        opacity: 0.9;
      }
    }
  }
</style>
